import About from '../components/About';
import Services from '../components/Services';
import FieldOps from '../components/FieldOps';
import Contact from '../components/Contact';
import Experience from '../components/Experience';

function Main() {
  return (
    <>
      <main>
        <Services />
        <FieldOps />
        <About />
        <Experience />
        <Contact />
      </main>
    </>
  );
}
export default Main;
